import { useTranslation } from "react-i18next";
import Shell from "src/components/Shell/Shell";
import { useGetDestinationsQuery } from "src/store/apis/pointsExchange";
import { usePointsExperienceListing } from "../../context/PointsExperienceListingContext";
import { POINTS_EXCHANGE_TYPE_VALUES } from "../../constants";
import { track } from "@amplitude/analytics-browser";

export default function BuyPoints() {
  const { t, i18n } = useTranslation();
  const { setSelectedType } = usePointsExperienceListing();
  const { data, isFetching, error } = useGetDestinationsQuery({ page: 1, pageSize: 10000, lang: i18n.language });
  const programs = data;
  return (
    <Shell loading={isFetching} error={error} data={programs}>
      <div className="flex flex-col gap-4">
        <div className="flex justify-end">
          <button
            type="button"
            onClick={() => {
              track("Category Selected", { category: POINTS_EXCHANGE_TYPE_VALUES.EXCHANGE });
              setSelectedType(POINTS_EXCHANGE_TYPE_VALUES.EXCHANGE);
            }}
            className="rounded-full bg-background-primary px-6 py-2 text-sm font-semibold text-font-inverted cursor-pointer transition-colors hover:opacity-90"
          >
            {t("PointsExchange.listing.exchangePointsTitle")}
          </button>
        </div>
        {programs?.map((program: any) => (
          <div key={program.code}>{program.name}</div>
        ))}
      </div>
    </Shell>
  );
}
